import api from '@/api'

const state = {
}

const mutations = {
}

const actions = {
  mapListHelpInfo ({commit}, data) {
    return new Promise((resolve, reject) => {
      api.mapListHelpInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({
              from: '/sweb/helpCenter/mapListHelpInfo',
              error: resData.error
            })
          }
        }
      }).catch(e => {
        reject({
          from: '/sweb/helpCenter/mapListHelpInfo',
          error: {
            code: 0,
            msg: '网络异常，请稍后再试'
          }
        })
      })
    })
  },
  submit ({commit}, data) {
    return new Promise((resolve, reject) => {
      api.submit(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          // console.log(res, 'res in else')
          if (resData.error) {
            reject({
              from: '/sweb/feedback/submit',
              error: resData.error
            })
          }
        }
      }).catch(e => {
        reject({
          from: '/sweb/feedback/submit',
          error: {
            code: 0,
            msg: '网络异常，请稍后再试'
          }
        })
      })
    })
  },
  list ({commit}, data) {
    return new Promise((resolve, reject) => {
      api.feedbackList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({
              from: '/sweb/feedback/listFeedback',
              error: resData.error
            })
          }
        }
      }).catch(e => {
        reject({
          from: '/sweb/feedback/listFeedback',
          error: {
            code: 0,
            msg: '网络异常，请稍后再试'
          }
        })
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/helpCenter.js